import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { Menu, BellIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { EnhancedSidebar } from '@/components/common/EnhancedSidebar';
import { useCurrentAdmin } from '@/hooks/redux';
import { useGetUnreadNotificationCountQuery } from '@/store/api/notificationApi';
import { cn } from '@/utils';

export function DashboardLayout() {
  const adminDetail = useCurrentAdmin();
  const [sidebarOpen, setSidebarOpen] = React.useState(true);
  const { data: unreadCount = 0 } = useGetUnreadNotificationCountQuery();

  const adminFullName = adminDetail?.firstname + ' ' + adminDetail?.lastname;
  const badgeLabel = unreadCount > 9 ? '9+' : unreadCount > 0 ? String(unreadCount) : null;

  return (
    <div className="h-screen overflow-hidden bg-background">
      {/* Enhanced Sidebar */}
      <EnhancedSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />

      {/* Main Content */}
      <div
        className={cn(
          'flex flex-col h-screen overflow-hidden transition-all duration-300',
          sidebarOpen ? 'lg:ml-64' : 'lg:ml-16'
        )}
      >
        {/* Top Navigation */}
        <header className="sticky top-0 z-40 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
          <div className="flex h-16 items-center px-4">
            {/* Mobile menu button */}
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="md:hidden"
            >
              <Menu className="h-5 w-5" />
            </Button>

            {/* Search */}
            <div className="flex flex-1 items-center space-x-4 px-6">
              {/* <div className="relative max-w-sm">
                <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                <Input placeholder="Search..." className="pl-9" />
              </div> */}
            </div>

            {/* Right side actions */}
            <div className="flex items-center space-x-4">
              {/* <ThemeSwitcher />

              <Button variant="ghost" size="icon">
                <Bell className="h-5 w-5" />
                <span className="sr-only">Notifications</span>
              </Button> */}
              <Link to={'/notifications'} className="relative">
                <BellIcon className="h-5 w-5" />
                {badgeLabel && (
                  <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-bold leading-none">
                    {badgeLabel}
                  </span>
                )}
              </Link>

              <div className="flex items-center gap-3 ">
                <div className="relative h-8 w-8 rounded-full overflow-hidden p-0">
                  {adminDetail?.profileImage ? (
                    <img
                      src={adminDetail?.profileImage || '/images/adminProfile.png'}
                      alt="Admin profile"
                      className="h-full w-full object-cover"
                    />
                  ) : (
                    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary text-primary-foreground text-sm">
                      A
                    </div>
                  )}

                  <span className="sr-only">Admin menu</span>
                </div>

                <div className="flex flex-col space-y-0.5">
                  <p className="text-sm font-medium leading-none truncate max-w-[120px]">
                    {adminFullName?.trim() || 'Admin'}
                  </p>
                  <p className="text-xs leading-none text-muted-foreground truncate max-w-[140px]">
                    {adminDetail?.email}
                  </p>
                </div>
              </div>
              {/* <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button
                    variant="ghost"
                    className="relative h-8 w-8 rounded-full overflow-hidden p-0"
                  >
                    {adminDetail?.profileImage ? (
                      <img
                        src={adminDetail?.profileImage || '/images/adminProfile.png'}
                        alt="Admin profile"
                        className="h-full w-full object-cover"
                      />
                    ) : (
                      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary text-primary-foreground text-sm">
                        {adminDetail?.firstname.charAt(0).toUpperCase()}
                      </div>
                    )}
                    <span className="sr-only">Admin menu</span>
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-56" align="end" forceMount>
                  <DropdownMenuLabel className="font-normal">
                    <div className="flex flex-col space-y-1">
                      <p className="text-sm font-medium leading-none truncate">
                        {adminFullName?.trim() || 'Admin'}
                      </p>
                      <p className="text-xs leading-none text-muted-foreground">
                        {adminDetail?.email}
                      </p>
                    </div>
                  </DropdownMenuLabel>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem>
                    <User className="mr-2 h-4 w-4" />
                    <span>Profile</span>
                  </DropdownMenuItem>
                  <DropdownMenuItem>
                    <Settings className="mr-2 h-4 w-4" />
                    <span>Settings</span>
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem onClick={handleLogout}>
                    <LogOut className="mr-2 h-4 w-4" />
                    <span>Log out</span>
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu> */}
            </div>
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
